'use strict';

angular.module('app.influencersPending', [])

.controller('AdminInfluencersPendingCtrl', function ($scope, $modal, $http, $rootScope, localStorageService, $window, adminService, $state) {
    $scope.loaded = false;
    $scope.InfluencersAll = [];
    $scope.currentPage = 1;
    $scope.pageSize = 25;
    $scope.fieldName = null;
    $scope.order = true;
    $scope.tempOrder = true;
    $scope.unapprovedId = null;
    $scope.newStatusId = null;
    var searchInfluencerURL = $rootScope.apiUrl + 'admin/searchPendingInfluencersMultiHashTags';
    var getNumberOfPendingInfluencersURL = $rootScope.apiUrl + 'admin/getNumberOfPendingInfluencers';
    var enableWatch = false;
    var menuElm = null;

    var definitions = angular.copy($rootScope.definitions);
    $scope.countries = definitions.countries;
    $scope.periods = definitions.timePeriods;
    $scope.platforms = definitions.platforms;

    $scope.mentions = [];

    $( "#hashtagSearch" ).autocomplete({
        source: function (request, response) {
            var data = {
                searchMention: request.term,
                // Only search hashtag keyword
                keywordTypeId: 3,
                pageSize: 100
            }
            var req = {
                url: $rootScope.apiUrl + 'discover/getRelativeMention',
                method: 'POST',
                loader: false,
                data: JSON.stringify(data)
            }
            var relativeMention = [];
            $http(req).success(function (dataResponse){
                angular.forEach(dataResponse.data, function(item) {
                    var reMention = {
                        label: item.keyword,
                        value: item.keyword
                    };
                    relativeMention.push(reMention);
                });
                response(relativeMention);
            });
        },
        select: function (event, ui) {
            if (ui && ui.item) {
                $scope.searchString = ui.item.value;
                $scope.searchPendingInfluencers(1);
            }
        },
        delay: 50,
        minLength: 1
    });

    if($scope.currentUser.role.accessLevel == 'achooAnalyst') {
        menuElm = angular.element('#leftmenu_influencer');
        if(menuElm != null){
            menuElm.addClass('bg-active');
            menuElm.find('.parent').addClass('parent-active');
            menuElm.find('.open-child').show();
        }
    }

    $scope.searchPendingInfluencers = function (pageIndex) {
        $scope.selectedPlatform = null;
        $scope.selectedCountryId = null;
        $scope.selectedPeriod = null;
        $scope.currentPage = pageIndex || $scope.currentPage;

        $scope.platforms.forEach(function (val) {
            if(val.ticked === true) {
                $scope.selectedPlatform = val.id;
                return;
            }
        });

        $scope.countries.forEach(function (val) {
            if(val.ticked === true) {
                $scope.selectedCountryId = val.id;
                return;
            }
        });

        $scope.periods.forEach(function (val) {
            if(val.ticked === true) {
                $scope.selectedPeriod = val.id;
                return;
            }
        });

        var searchData = {
            selectedPlatform:   $scope.selectedPlatform,
            selectedCountryId:  $scope.selectedCountryId,
            fromPeriodDays:     $scope.selectedPeriod,
            searchString:       $scope.searchString,
            pageNo:             $scope.currentPage,
            sortByColumn:       $scope.fieldName,
            sortType:           $scope.order
        };

        $scope.sendHttpPOST(searchData, searchInfluencerURL);
    }

    $scope.sendHttpPOST = function(data, url){
        var req = {
            url: url,
            method: 'POST',
            data: JSON.stringify(data)
        };

        $http(req).success(function (response) {
            $scope.influencer = response.data;
            enableWatch = true;
        }) .error(function (response) {
            var errorModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                windowClass: 'modal-dialog-mention-error'
            });
            $scope.errorModalInstance = errorModalInstance;
            $scope.errorMessage = response.message;
        });

        var request = {
            url: getNumberOfPendingInfluencersURL,
            method: 'POST',
            data: JSON.stringify(data)
        }

        $http(request).success(function (responseNumberOfPendingInfluencer) {
            $scope.number = responseNumberOfPendingInfluencer.totalRow;
            $scope.pagination();
        }) .error(function (responseNumberOfPendingInfluencer) {
            var errorModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                windowClass: 'modal-dialog-mention-error'
            });
            $scope.errorModalInstance = errorModalInstance;
            $scope.errorMessage = responseNumberOfPendingInfluencer.message;
        });
    };

    $scope.pagination = function(){
    	$scope.pages = adminService.pagination($scope.number, $scope.pageSize);
    };

    $scope.searchPendingInfluencers(1);

    $scope.platformIcon = function (platform_id) {
        return adminService.getPlatformIcon(platform_id);
    }

    $scope.influencerDetails = function (id, infIndex) {
        var influencersDetailsCurrentPage = $scope.currentPage;
        var influencerDetailsModalInstance = $modal.open({
            scope: $scope,
            templateUrl: 'app/admin/influencerManagement/influencer-management-influencers-pending/influencers-pending-details.html?app_v=deployDate',
            controller: 'InfluencerDetailsCtrl'
        });
        influencerDetailsModalInstance.result.then(function () {
            $scope.searchPendingInfluencers($scope.currentPage);
        }, function (reason) {
            if(reason = 'escape key press'){
                $scope.searchPendingInfluencers($scope.currentPage);
            }
        });
        $scope.influencerDetailsModalInstance = influencerDetailsModalInstance;
        $scope.id = id;
        $scope.influencerIndex = infIndex;
        $scope.flag = false;
        $scope.selectedPlatform;
    };

    $scope.newInfluencerModalHandler = function () {
        var newInfluencerCurrentPage = $scope.currentPage;
        var modalInstance = $modal.open({
            scope: $scope,
            templateUrl: 'app/admin/influencerManagement/influencer-management-influencers-pending/influencers-pending-add-new.html?app_v=deployDate',
            controller: 'AddNewInfluencerCtrl'
        });

        $scope.modalInstance = modalInstance;
        $scope.flag = false;
        modalInstance.result.then(function () {
          $scope.searchPendingInfluencers(newInfluencerCurrentPage);
        }, function () {

        });
    };

    $scope.goToURL = function(selectedChannel, $event) {
        var platformDomain = null;
        var channelDomain = null;
        var getDomainUrl = $rootScope.apiUrl + 'admin/getPlarformDomainUrl/' + selectedChannel.channel_id;
        $http.get(getDomainUrl, {loader: false})
            .success(function(responseGetDomain){
                platformDomain = responseGetDomain.data.domain;
                channelDomain = responseGetDomain.channel.handle;
                if(responseGetDomain.channel.isLinked == 1){
                    if(responseGetDomain.channel.platform_id == 6) {
                        $window.open(platformDomain == null ? 'http://' + channelDomain : 'https://' + platformDomain + responseGetDomain.channel.youtubeType.toLowerCase() + '/' + selectedChannel.handle, '_blank');
                    } else {
                        $window.open(platformDomain == null ? 'http://' + channelDomain : 'https://' + platformDomain + responseGetDomain.channel.handle, '_blank');
                    }
                }
            });
        $event.stopPropagation();
    };

    $scope.keyDownScrollCountry = function($event){
        $scope.keyDownCharCode = $event.keyCode;
        for(var i = 0; i < $('.filterOptions').length; i++){
            var isCountryElement = false;
            var tempElements = $('.filterOptions')[i];

            if(tempElements.firstElementChild.id != null && tempElements.firstElementChild.id !== undefined && tempElements.firstElementChild.id == ("selectCountry")){
                isCountryElement = true;
            }

            if(isCountryElement){
                var tempCountries = tempElements.firstElementChild.lastElementChild.firstElementChild;
                for(var k = 0; k < tempCountries.length; k++){
                    var countryItem = tempCountries[k];
                    var elementCharcode = countryItem.nextElementSibling.firstChild.data.charCodeAt(1);
                    if($scope.keyDownCharCode == elementCharcode){
                        var top = countryItem.parentElement.parentElement.parentElement.offsetTop;
                        var parent = countryItem.parentElement.parentElement.parentElement.parentElement;
                        parent.scrollTop = top;
                        break;
                    }
                }
            }
        }
    }

    $scope.resetFilter = function () {
        $scope.selectedPlatform = null;
        $scope.selectedCountryId = null;
        $scope.selectedPeriod = null;

        $scope.platforms.forEach(function (val) {
            val.ticked = false;
        });

        $scope.countries.forEach(function (val) {
            val.ticked = false;
        });

        $scope.periods.forEach(function (val) {
            val.ticked = false;
        });
    }
})
